import { createContext } from 'react';
import { MatchCardContext, MatchCardState } from './match-card';

export const initialState: MatchCardState = {
  isExpanded: false,
};

export default createContext<MatchCardContext>({ state: {}, actions: {} } as MatchCardContext);
